export class ClosePositionData {
    constructor(position, tif, quantityToClose, isAllowOTHTrading, mutualPositionsIds) {
        this.position = position;
        this.tif = tif;
        this.quantityToClose = quantityToClose;
        this.isAllowOTHTrading = isAllowOTHTrading;
        this.mutualPositionIDs = mutualPositionsIds;
    }
}
